import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const MODEL_FAMILY_DELETE_RESOURCE = "model-family" as const;
export const MODEL_FAMILY_DELETE_API_PATH = `/v1/${MODEL_FAMILY_DELETE_RESOURCE}/{uuid}` as const;

export const useModelFamilyDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      await alphartisApiAxios.delete<void>(`/v1/${MODEL_FAMILY_DELETE_RESOURCE}/${uuid}`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MODEL_FAMILY_DELETE_RESOURCE],
      });
    },
  });
};
